<template>
  <footer class="footer px-4 ">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted dtac-footer">
          © {{ year }}
          <a
            href="https://www.dtac.co.th"
            class="font-weight-bold ml-1"
            target="_blank"
            >dtac</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.dtac-footer {
  color: #1a1a1a !important;
}
</style>
